<div class="relative w-full" (keydown.escape)="closeDropdown()">
  <button hlmBtn variant="ghost" type="button"
    class="w-full min-w-0 flex items-center gap-2.5 px-2 py-1.5 text-left hover:bg-muted transition-colors justify-start h-auto"
    aria-label="Organisation wechseln" aria-haspopup="dialog" [attr.aria-expanded]="isOpen()" (click)="toggleDropdown()">
    <hlm-avatar class="size-8 shrink-0 rounded-lg">
      @if (currentOrganization()?.icon) {
        <img hlmAvatarImage [src]="currentOrganization()!.icon!" [alt]="currentOrganization()!.name" class="object-cover" />
      }
      <span hlmAvatarFallback class="rounded-lg text-white font-bold text-sm" [style.background-color]="currentOrgColor()">{{ currentOrgInitials() }}</span>
    </hlm-avatar>
    <div class="flex-1 min-w-0 text-left overflow-hidden">
      <div class="font-bold text-sm text-foreground truncate leading-tight">{{ currentOrganization()?.name || 'Organisation auswählen' }}</div>
      <div class="text-xs text-muted-foreground truncate mt-0.5">
        {{ currentAccess()?.accessType === 'platform_admin' ? 'Systemadmin' : getRoleDisplayText(currentOrganization()?.userRole) }}
      </div>
    </div>
  </button>

  @if (isOpen()) {
    <div role="dialog" aria-label="Organisation wechseln" class="organization-menu ks-glass-3 absolute top-[calc(100%+0.5rem)] left-0 z-50 overflow-hidden rounded-xl border border-border/70 p-1.5 shadow-xl">
      <div class="flex items-center gap-2 border-b border-border px-2.5 py-1.5">
        <ng-icon name="lucideSearch" class="size-4 shrink-0 text-muted-foreground" />
        <input type="text" aria-label="Organisationen durchsuchen" placeholder="Organisation suchen"
          class="h-8 min-w-0 flex-1 rounded-md bg-transparent text-sm outline-none placeholder:text-muted-foreground"
          (input)="onSearchChange($any($event.target).value)" [value]="searchQuery()" />
      </div>
      <div class="max-h-[min(16rem,50vh)] overflow-y-auto py-1">
        @if (isLoading()) {
          <div role="status" class="flex items-center justify-center py-6">
            <hlm-spinner class="w-6 h-6" /><span class="ml-2 text-sm">Wird geladen …</span>
          </div>
        } @else {
          @for (org of visibleOrganizations(); track org.id) {
            <button type="button" class="flex w-full min-w-0 items-center gap-2.5 rounded-md px-2.5 py-2 text-left text-sm hover:bg-muted focus-visible:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              (click)="selectOrganization(org)" [class.bg-accent]="currentOrganization()?.id === org.id">
              <span class="flex size-8 shrink-0 items-center justify-center rounded-lg text-xs font-bold text-white" [style.background-color]="avatarColor(org)">
                {{ org.name.charAt(0).toUpperCase() }}
              </span>
              <div class="flex-1 min-w-0">
                <span class="block font-normal truncate">{{ org.name }}</span>
                <span class="block truncate text-xs text-muted-foreground">
                  {{ org.accessType === 'platform_admin' ? 'Systemadmin' : getRoleDisplayText(org.userRole) }}
                </span>
              </div>
              @if (currentOrganization()?.id === org.id) { <ng-icon name="lucideCheck" class="size-4 shrink-0 text-foreground" /> }
            </button>
          } @empty {
            <p class="py-6 text-center text-sm text-muted-foreground">Keine Organisationen gefunden</p>
          }
        }
      </div>
      <div class="flex items-center gap-1 border-t border-border pt-1">
        <button type="button"
          class="min-w-0 flex-1 rounded-md px-2.5 py-2 text-left text-sm text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          (click)="navigateToOnboarding()">
          Alle Organisationen anzeigen
        </button>
        <button hlmBtn variant="ghost" size="icon" type="button"
          class="!size-8 shrink-0 rounded-md" aria-label="Neue Organisation erstellen" title="Neue Organisation erstellen"
          (click)="createOrganization()">
          <ng-icon name="lucidePlus" class="size-4" />
        </button>
      </div>
    </div>
  }
</div>
@if (isOpen()) { <div class="fixed inset-0 z-40" (click)="closeDropdown()"></div> }
